class LogoutConfirm {
    constructor(link) {
        this.link = link;
        this.logoutUrl = link.href;
        this.init();
    }

    init() {
        this.link.addEventListener("click", (e) => {
            e.preventDefault();
            if (window.confirm("Вы уверены, что хотите выйти?")) {
                window.open(this.logoutUrl, "_self");
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const link = document.querySelector('[data-logout-link]');

    if (!link) return;

    new LogoutConfirm(link);
})